// Mirrors `MemexesHelper::SORTS` in github/github so the React projects index
// stays in sync with the Rails-rendered dropdown and the `sort:` qualifier
// supported by `Search::Queries::MemexProjectQuery`.
export const PROJECT_SORT_OPTIONS = [
  {label: 'Recently updated', value: 'updated-desc'},
  {label: 'Newest', value: 'created-desc'},
  {label: 'Oldest', value: 'created-asc'},
  {label: 'Least recently updated', value: 'updated-asc'},
  {label: 'Name', value: 'title-asc'},
] as const

export type ProjectSortOption = (typeof PROJECT_SORT_OPTIONS)[number]
export type ProjectSortValue = ProjectSortOption['value']

const DEFAULT_PROJECT_SORT_OPTION: ProjectSortOption = PROJECT_SORT_OPTIONS[0]
export const DEFAULT_PROJECT_SORT: ProjectSortValue = DEFAULT_PROJECT_SORT_OPTION.value

export function isProjectSortValue(value: string | null | undefined): value is ProjectSortValue {
  return PROJECT_SORT_OPTIONS.some(option => option.value === value)
}

export function getProjectSortOption(value: ProjectSortValue): ProjectSortOption {
  return PROJECT_SORT_OPTIONS.find(option => option.value === value) ?? DEFAULT_PROJECT_SORT_OPTION
}
